import { Sparkle, Heart } from "@phosphor-icons/react";
import { GlassQuoteCard } from "./GlassQuoteCard";
import { GlassOracleCard } from "./GlassOracleCard";
import { StoneVsGlassGame } from "./StoneVsGlassGame";
import { ScheibiMascot } from "./ScheibiMascot";

const Cloud = ({ className, style }) => (
  <svg viewBox="0 0 100 40" className={className} style={style} aria-hidden="true">
    <path d="M20 32 Q6 32 8 22 Q10 12 22 14 Q26 4 38 6 Q50 8 50 16 Q62 12 66 20 Q78 18 78 26 Q78 32 66 32 Z" fill="white" opacity="0.85" />
  </svg>
);

const Star = ({ className, size = 14, color = "text-amber-300", delay = "0s" }) => (
  <Sparkle size={size} weight="fill" className={`${color} fz-twinkle absolute ${className}`} style={{ animationDelay: delay }} aria-hidden="true" />
);

const Landscape = () => (
  <svg viewBox="0 0 1440 150" preserveAspectRatio="none" className="absolute bottom-0 inset-x-0 w-full h-24 md:h-32 pointer-events-none" aria-hidden="true">
    <path d="M0 90 Q360 30 720 80 T1440 70 L1440 150 L0 150 Z" fill="#bbf7d0" opacity="0.7" />
    <path d="M0 110 Q480 60 900 105 T1440 100 L1440 150 L0 150 Z" fill="#86efac" opacity="0.55" />
    <path d="M0 132 Q720 112 1440 130 L1440 142 Q720 124 0 144 Z" fill="#cbd5e1" opacity="0.8" />
    <g opacity="0.9">
      <circle cx="200" cy="98" r="4" fill="#f472b6" /><rect x="199" y="100" width="2" height="10" fill="#16a34a" />
      <circle cx="380" cy="88" r="4" fill="#fbbf24" /><rect x="379" y="90" width="2" height="10" fill="#16a34a" />
      <circle cx="1100" cy="94" r="4" fill="#a78bfa" /><rect x="1099" y="96" width="2" height="10" fill="#16a34a" />
      <ellipse cx="600" cy="100" rx="18" ry="9" fill="#4ade80" opacity="0.7" />
      <ellipse cx="1280" cy="92" rx="22" ry="10" fill="#4ade80" opacity="0.6" />
    </g>
  </svg>
);

export const FunZone = () => (
  <section className="relative overflow-hidden mt-14 bg-gradient-to-b from-slate-50 via-sky-50 to-sky-100" data-testid="fun-zone" aria-label="Unterhaltung während der Wartezeit">
    <Cloud className="absolute top-10 left-[4%] w-24 md:w-32 fz-float pointer-events-none" />
    <Cloud className="absolute top-24 right-[6%] w-16 md:w-24 fz-float pointer-events-none" style={{ animationDelay: "2s" }} />
    <Star className="top-16 left-[18%]" size={16} />
    <Star className="top-32 right-[22%]" color="text-sky-300" delay="1s" />
    <Star className="top-52 left-[8%]" size={12} color="text-violet-300" delay="2s" />
    <Star className="top-64 right-[10%]" size={18} delay="0.5s" />

    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-20 pb-36 md:pb-44">
      <div className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-sky-600">Vertreib dir kurz die Zeit.</p>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
          Während wir uns um deine Scheibe kümmern&nbsp;…
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" aria-hidden="true">
          <span className="h-1 w-10 rounded-full bg-amber-300" />
          <Sparkle size={16} weight="fill" className="text-amber-400" />
          <span className="h-1 w-10 rounded-full bg-sky-300" />
        </div>
      </div>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
        <GlassQuoteCard />
        <GlassOracleCard />
        <div className="md:col-span-2 lg:col-span-1 md:max-w-md md:mx-auto md:w-full lg:max-w-none">
          <StoneVsGlassGame />
        </div>
      </div>

      <div className="mt-14 text-center" data-testid="fun-zone-thanks">
        <Heart size={22} weight="fill" className="text-blue-500 mx-auto" aria-hidden="true" />
        <p className="mt-2 text-sm font-semibold text-slate-700">Danke, dass du Servus Autoglas vertraust!</p>
        <p className="mt-0.5 text-xs text-slate-500">Wir geben alles für deine klare Sicht.</p>
      </div>
    </div>

    <Landscape />
    <ScheibiMascot />
  </section>
);
